import styled from 'styled-components';

export const ModalContentSC = styled.div`
  .title {
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 32px;
    margin-bottom: 8px;

    text-align: center;
    color: #171d42;
  }

  .sub-title {
    margin-bottom: 35px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;

    text-align: center;
    color: #464b5d;
  }

  .actions-wrapper {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    button:not(:last-child) {
      margin-right: 16px;
    }
  }

  @media screen and (max-width: 900px) {
    .actions-wrapper {
      flex-direction: column;

      button {
        margin-right: 0 !important;

        &:not(:last-child) {
          margin-bottom: 8px;
        }
      }
    }
  }
`;
